import React from "react";
import { Table } from "antd";
import { WebApiModelsCustomListField } from "../../../Repository/eventbookyapi";
import { ColumnsType } from "antd/lib/table";

interface UploadCustomListItemPreviewTableProps {
    data: any[];
    fieldSettings: WebApiModelsCustomListField[];
    showMemberIdColumn?: boolean;
}

const UploadCustomListItemPreviewTable: React.FC<UploadCustomListItemPreviewTableProps> = ({
    data,
    fieldSettings,
    showMemberIdColumn,
}) => {
    const memberIdColumn = showMemberIdColumn
        ? [{
            title: "MedlemId",
            dataIndex: (data[0]?.memberId !== undefined ? "memberId" : "medlemsid"),
            key: "memberId_preview",
        }]
        : [];

    const columns: ColumnsType<any> = [
        ...memberIdColumn,
        ...fieldSettings
            .filter(f => f.nameAdmin)
            .map(f => ({
                title: f.nameAdmin,
                dataIndex: f.nameAdmin as string,
                key: f.id !== undefined && f.id !== null ? f.id.toString() : f.nameAdmin || "",
            }))
    ];

    return (
        <Table
            dataSource={data}
            columns={columns}
            rowKey={(_, idx) => idx!.toString()}
            pagination={false}
            size="small"
        />
    );
};

export default UploadCustomListItemPreviewTable;